<template>
    <div class="container">
        <div class="feedback-content">
            <div class="item">
                <div class="item-name">问题类型：</div>
                <div class="item-info">{{feedback.type}}</div>
            </div>
            <div class="item">
                <div class="item-name">反馈时间：</div>
                <div class="item-info">{{formatTime(feedback.upload_time*1000)}}</div>
            </div>
            <div class="feedback-title">详细说明：</div>
            <div class="feedback-text">{{feedback.content}}</div>
            <div class="pic-list">
                <img :src="'http://www.diva5serica.com:83/public/uploads/'+itme" alt="" class="pic" v-for="(itme,index) in picList" :key="index">
            </div>
        </div>
    </div>
</template>
<script>
import {feedback_details} from '../api/my'
import moment from 'moment'
export default {
    data() {
        return {
            feedback:'',
            picList:[],
        };
    },
    computed: {},
    methods: {
        details(){
            feedback_details(this.$route.query.id).then(res=>{
                console.log(res)
                if(res.status==200){
                    this.feedback=res.data.feedback[0];
                    this.picList=JSON.parse(res.data.feedback[0].pic)
                }
            })
        },
        formatTime(time){
            return moment(time).format("YYYY年MM月DD日 HH:mm")
        }
    },
    created() {
        this.details()
    },
};
</script>
<style lang='less' scoped>
.container{
    padding: 16px;
}
.feedback-content{
    background-color: #fff;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 10px;
}
.item{
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}
.item-name{
    height: 14px;
    line-height: 14px;
    font-size: 14px;
    font-weight: 500;
    color: #999999;
    width: 25%;
}
.item-info{
    height: 14px;
    line-height: 14px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
}
.feedback-title{
    height: 14px;
    line-height: 14px;
    font-size: 14px;
    font-weight: 500;
    color: #999999;
    margin-bottom: 10px;
}
.feedback-text{
    line-height: 24px;
    font-size: 14px;
    color: #333;
    text-indent: 2em;
}
.pic-list{
    margin-top: 12px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.pic{
    display: block;
    height: 60px;
    width: 60px;
    border-radius: 4px;
    margin-right: 10px;
}
</style>